import axios from 'axios';
import { getUser, handleLogout } from 'src/utils/Common';
import { getToken, getTokenWs, getIpAddress } from './Common';
import { handleTransactionResponse } from './notificationManager';
import { generalActions } from 'src/store/slices/generalSlice';
import { store } from 'src/store/configureAppStore';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

function addTechnicianToURL(url) {
  return '/Technician' + url;
}

instance.interceptors.request.use(
  (config) => {
    config.url = addTechnicianToURL(config.url);
    const AuthToken = getToken();
    const AuthTokenWs = getTokenWs();
    const IpAddress = getIpAddress();
    const user = getUser();
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${AuthToken}`,
      SessionToken: AuthToken,
      SessionTokenWs: AuthTokenWs,
      IpAddress: IpAddress || '',
      'Auth-UserId': user ? user.UserId : '',
      'max-age': 86400,
      'X-Frame-Options': 'DENY',
      'X-XSS-Protection': '1;mode=block',
      Language: localStorage.getItem('i18nextLng')
    };
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  async function (response) {
    return await handleTransactionResponse(response, store, generalActions);
  },
  function (error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error === '401 Unauthorized'
    ) {
      alert(
        'Başka bir cihazdan giriş yaptığınız için oturumunuz sonlandırıldı!..'
      );
      handleLogout();
    }
    return Promise.reject(error);
  }
);

export default instance;
